<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'User Birthdays'"></cardHead>
      <load-area v-if="data == null"></load-area>
      <dataTable
        v-if="data != null"
        :name="'OnlineReservationCustomer'"
        ref="agGrid"
        :data="data"
        :columnDefs="columnDefs"
        :rowClassRules="{
          // row style function
          success: (params) => {
            // var numSickDays = params.data;
            return (
              new Date(
                new Date(params?.data?.BirthDate).setFullYear(
                  new Date(params?.data.BirthDate).getFullYear() +
                    params?.data.Age
                )
              ).toDateString() == new Date().toDateString()
            );
          },
          sended: (params) => {
            return params.data.sended == true;
          },
        }"
        @sendSms="sendSms"
      ></dataTable>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "birthdays",
  // props:["data","get"],
  data() {
    return {
      tab: "Customers",
      columnDefs: [
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
        },
        {
          headerName: "CustomerName",
          field: "CustomerName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
        },
        {
          headerName: "Email",
          field: "Email",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
        },
        {
          headerName: "Age",
          field: "Age",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 80,
        },
        {
          headerName: "BirthDate",
          field: "BirthDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          width: 120,
          valueFormatter: function(params) {
            return moment(new Date(params.value)).format("DD.MM.YYYY");
          },
        },
        {
          headerName: "C.Active",
          field: "CustomerActive",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          width: 100,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Active",
          field: "UserActive",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          width: 80,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Deleted",
          field: "Deleted",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          width: 90,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "",
          type: "action",
          width: 45,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-success",
              text: '<i class="fas fa-mobile-alt"></i>',
              emit: "sendSms",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
          cellRenderer: this.$BtnCellRenderer,
          cellRendererParams: {
            clicked: function(field) {
              this.$emit(field.emit, field.data);
            },
          },
        },
      ],
      data: null,
      detailShow: null,
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .post(`Users/Birthdays`, {
          FromDate: null,
          ToDate: null,
        })
        .then((response) => {
          this.data = response.data.sort((x, y) => {
            return (
              new Date(x.BirthDate).setFullYear(
                new Date(x.BirthDate).getFullYear() + x.Age
              ) -
              new Date(y.BirthDate).setFullYear(
                new Date(y.BirthDate).getFullYear() + y.Age
              )
            );
          });
        });
    },
    sendSms(data) {
      this.$appAxiosAdmin
        .get(`Users/SendHappyBirthDayMessage/` + data.Id)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Birthday sms sent.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
          this.data.filter((x) => x.Id == data.Id)[0].sended = true;
        });
    },
  },
};
</script>
<style scoped>
.head {
  padding: 10px 5px;
}
/deep/ .sended .btn {
  display: none;
}
</style>
